import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileForUpload } from 'common-logic';
import { MatTooltip } from '@angular/material/tooltip';
import { TextOverFlowTooltipDirective } from '../directives/text-over-flow-tooltip.directive';

@Component({
  selector: 'common-files-preview',
  standalone: true,
  imports: [CommonModule, MatTooltip, TextOverFlowTooltipDirective],
  templateUrl: './files-preview.component.html',
  styleUrl: './files-preview.component.scss',
})
export class FilesPreviewComponent implements OnChanges {
  @ViewChild('filesContainer') filesContainer?: HTMLElement;
  @Input() files: FileForUpload[] = [];
  @Input() loading = false;
  @Input() maxFiles?: number;
  @Input() displayMaxFilesError = false;
  @Output() removeFile = new EventEmitter<number>();
  fileIconSvg = {
    pdf: 'assets/file-types-preview/pdf-file.svg',
    zip: 'assets/file-types-preview/zip-file.svg',
    other: 'assets/file-types-preview/other-file.svg',
  };

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    this.files = (this.maxFiles ? this.files.slice(0, this.maxFiles) : this.files).map((file) => {
      const fileTypeShort = file.type?.split('/')[0] || 'other';
      return {
        ...file,
        name: file.name,
        type: file.type,
        fileTypeShort,
      };
    });
  }

  onFileLoaded(file: FileForUpload) {
    file.loaded = true;
  }

  onDelete(index: number) {
    this.removeFile.emit(index);
  }
}
